// Auto generated file, do not manually modify!
// com.hotpads.customeranalytics.api.web.external.portalanalytics.MoodysAnalyticsWebApiHandler

import { getClient } from '../../client';
import { httpApiRequest } from '@zg-rentals/ts-client-http-client';

import type {
  MoodysAnalyticsForListingRequestDto,
  MoodysAnalyticsForRegionRequestDto,
  MoodysAnalyticsResponseDto,
  MoodysAnalyticsResponseWithTypeDto,
} from '../..';

export const MoodysAnalyticsWebApiHandler_getMoodysAnalyticsForListing_Path =
  '/api/web/moodysAnalyticsPaths/getMoodysAnalyticsForListing';

export const MoodysAnalyticsWebApiHandler_getMoodysAnalyticsForListing = (
  postData: MoodysAnalyticsForListingRequestDto,
  client = getClient(),
) => {
  return httpApiRequest<never, MoodysAnalyticsForListingRequestDto, MoodysAnalyticsResponseWithTypeDto>(
    {
      endpoint: MoodysAnalyticsWebApiHandler_getMoodysAnalyticsForListing_Path,
      method: 'POST',
      contextPath: '/customer-analytics',
      postData: postData,
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const MoodysAnalyticsWebApiHandler_getMoodysAnalyticsForRegion_Path =
  '/api/web/moodysAnalyticsPaths/getMoodysAnalyticsForRegion';

export const MoodysAnalyticsWebApiHandler_getMoodysAnalyticsForRegion = (
  postData: MoodysAnalyticsForRegionRequestDto,
  client = getClient(),
) => {
  return httpApiRequest<never, MoodysAnalyticsForRegionRequestDto, Array<MoodysAnalyticsResponseDto>>(
    {
      endpoint: MoodysAnalyticsWebApiHandler_getMoodysAnalyticsForRegion_Path,
      method: 'POST',
      contextPath: '/customer-analytics',
      postData: postData,
      unwrapApiLayerResponse: true,
    },
    client,
  );
};
